// Your routes — and the navigation binding's, which is the part worth knowing.
//
// THIS FILE IS REPLACED when the navigation shell is re-applied. `bottom-tabs`,
// `stack` and `sidebar` produce different routers, so the binding owns it and
// `appfactory spec apply` rewrites it with `overwrite: true`. Commit before
// running one, because the two edits below are the kind an apply takes with it.
//
// TWO THINGS ARE CHANGED FROM THE GENERATED VERSION.
//
// 1. THE TABS. The generated array is `PRIMARY_ROUTES`, and exactly one screen
//    in this plan is primary — which produces a tab bar with a single tab in
//    it, and no way at all to reach Radar, Week or Settings. `roles` grades
//    IMPORTANCE for QA; it is not a claim about what belongs in the bar. The
//    four destinations are listed explicitly here. Warning detail is not one of
//    them: it is pushed from the strip on Now and from a notification, and a
//    tab for a screen that is usually empty is a tab nobody presses.
//
// 2. THE ROUTE TREE. The generated tree mounts the screens under `/tabs/` and
//    puts `{ path: '/', redirect: HOME }` above it. That is fine for a plan
//    whose primary screen lives at `/list` — and a redirect loop for this one,
//    whose primary screen IS `/`: HOME resolves to `/`, so `/` redirects to
//    itself and Vue Router throws on the very first navigation. The shell is
//    mounted AT `/` instead, with each screen as a child of it, so the paths
//    the plan declares are the paths the app actually has — `/`, `/radar`,
//    `/week`, `/settings`, `/warnings/:id` — and nothing redirects anywhere.

import { createRouter, createMemoryHistory } from '@ionic/vue-router';
import {
  rainyOutline, navigateOutline, calendarOutline, settingsOutline,
} from 'ionicons/icons';

import TabsShell from './pages/TabsShell.vue';
import { PRODUCT_ROUTES, HOME_ROUTE } from './product-routes.js';

/** Where the app opens. main.js pushes this. */
export const HOME = HOME_ROUTE;

const ICONS = {
  now: rainyOutline,
  radar: navigateOutline,
  week: calendarOutline,
  settings: settingsOutline,
};

// The bar, in order. Destinations only.
//
// `icon` is an IMPORTED ionicon, not a name. `<ion-icon name="rainy">` fetches
// its SVG from a CDN at runtime, which this app's content-security-policy
// blocks and an offline app could not reach anyway — you get an invisible tab
// bar that works on your machine and is blank on a plane.
export const TABS = ['now', 'radar', 'week', 'settings']
  .map((id) => PRODUCT_ROUTES.find((r) => r.id === id))
  .filter(Boolean)
  .map((r) => ({ name: r.id, label: r.label, path: r.path, icon: ICONS[r.id] }));

export default createRouter({
  history: createMemoryHistory(),
  routes: [
    {
      // The tab shell owns its own outlet, so each tab keeps its own navigation
      // stack: pushing /warnings/wrn-1 leaves the tab bar in place with a
      // working back button, and switching away and back returns you to it.
      path: '/',
      component: TabsShell,
      children: PRODUCT_ROUTES.map((r) => ({
        // Relative, so each screen is a child of the shell rather than a
        // second absolute route that happens to render inside it. '/' becomes
        // '', which is the index child.
        path: r.path.replace(/^\//, ''),
        name: r.id,
        component: r.component,
        // `props: true` on every route, so a screen with `:id` in its path gets
        // it as a prop as well as through useRoute(). A detail screen that has
        // to reach for the router to learn which record it is showing is a
        // screen that cannot be tested without one.
        props: true,
      })),
    },
  ],
});
